import { Button, Icon } from 'dcloud-shared-ui';
import React, { ReactElement } from 'react';
import styles from './TableActions.module.css';

export interface MailServerTableActionsProps {
  onDeleteClick: () => void;
}

export function MailServerTableActions({
  onDeleteClick,
}: MailServerTableActionsProps): ReactElement {
  return (
    <ul aria-label="Delete mail Server" className={styles.root}>
      <li className={styles.action}>
        <Button
          colour="link"
          onClick={() => onDeleteClick()}
          testId="mail-server-table-actions-delete"
        >
          <Icon name="delete" />
        </Button>
      </li>
    </ul>
  );
}
